import { render } from "./p-mode-chair-controls.vue?vue&type=template&id=05aef3d4"
import script from "./p-mode-chair-controls.vue?vue&type=script&lang=js"
export * from "./p-mode-chair-controls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__